import { Tooltip } from "primereact/tooltip";
import { Chip } from "primereact/chip";

import { ContentTag } from "sj-ui-toolkit/src/atlas/components";
import { formatElapsedTime } from "sj-ui-toolkit/src/utils";

import { useTournamentContext } from "../../../context/TournamentContext";

export default function TournamentContentInfo({ lessonType, title, description }) {
  const { elapsedTime, maxPoints, attemptsCount } = useTournamentContext();

  // Build tooltip content from attempts
  const tooltipContent =
    attemptsCount && attemptsCount.length > 0
      ? `${attemptsCount.map(attempt => `Attempt ${attempt.count}: -${attempt.pointsDecrease} pts`).join("\n")}`
      : "No attempts yet";

  return (
    <div data-test-id="lesson-info">
      <div>
        <ContentTag value={lessonType} />
        <h1 className="atlas-h4 mt-4.5 mb-2">{title}</h1>
        <p>{description}</p>
      </div>
      <div className="flex flex-row mt-6 body-sm">
        {attemptsCount && attemptsCount.length > 0 && (
          <Tooltip target=".tournament-content-points" style={{ whiteSpace: "pre-line" }} />
        )}
        <div className="flex-1 flex flex-col gap-1">
          <div className="text-muted">Max points</div>
          <div>
            <Chip
              data-pr-tooltip={tooltipContent}
              label={maxPoints}
              className="tournament-content-points chip-label body-md"
            />
          </div>
        </div>
        <div className="flex-1 flex flex-col gap-1">
          <div className="text-muted">Time elapsed</div>
          <div>
            <Chip className="chip-label body-md" label={formatElapsedTime(elapsedTime)} />
          </div>
        </div>
      </div>
    </div>
  );
}
